@file:OptIn(ExperimentalComposeUiApi::class, ExperimentalResourceApi::class)

import androidx.compose.foundation.*
import androidx.compose.foundation.gestures.animateScrollBy
import androidx.compose.foundation.gestures.scrollBy
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.CanvasBasedWindow
import com.haeyum.kug_seoul.generated.resources.Res
import com.haeyum.kug_seoul.generated.resources.*
import kotlinx.browser.window
import kotlinx.coroutines.*
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.TouchEvent
import org.w3c.dom.events.EventListener
import org.w3c.dom.get

fun main() {
    onWasmReady {
        CanvasBasedWindow("PangMoo") {
            KugTheme {
                val screenWidth by produceState(1f) {
                    fun sendCalcWidthValue() {
                        value = window.innerWidth.let { width ->
                            if (width >= 2160)
                                0.4f
                            else if (width >= 1920)
                                0.45f
                            else if (width >= 1600)
                                0.5f
                            else if (width >= 1440)
                                0.55f
                            else if (width >= 1200)
                                0.6f
                            else if (width >= 1080)
                                0.65f
                            else if (width >= 768)
                                0.7f
                            else if (width >= 576)
                                0.75f
                            else
                                0.8f
                        }
                    }

                    sendCalcWidthValue()

                    window.addEventListener("resize", EventListener {
                        sendCalcWidthValue()
                    })
                }

                val scrollState = rememberScrollState()
                val coroutineScope = rememberCoroutineScope()

//                LaunchedEffect(Unit) {
//                    var startPosition = 0
//                    var endPosition = 0
//                    var prevPosition = 0
//
//                    var job: Job? = null
//
//                    window.run {
//                        addEventListener(
//                            type = "touchstart",
//                            callback = EventListener { event ->
//                                val event = event as TouchEvent
//
//                                event.touches[0]?.let {
//                                    startPosition = it.clientY
//                                    endPosition = it.clientY
//                                    prevPosition = startPosition
//                                }
//                            }
//                        )
//
//                        addEventListener(
//                            "touchmove",
//                            EventListener { event ->
//                                val event = event as TouchEvent
//
//                                event.touches[0]?.let {
//                                    coroutineScope.launch {
//                                        launch {
//                                            scrollState.scrollBy((prevPosition - it.clientY).toFloat() * 3f)
//                                            prevPosition = it.clientY
//                                            endPosition = it.clientY
//                                            awaitAnimationFrame()
//                                        }
//
//                                        launch {
//                                            job = CoroutineScope(Dispatchers.Default).launch {
//                                                awaitAnimationFrame()
//                                                delay(100)
//                                                startPosition = prevPosition
//                                            }
//                                        }
//                                    }
//                                }
//                            }
//                        )
//
//                        addEventListener(
//                            "touchend",
//                            EventListener { _ ->
//                                coroutineScope.launch {
//                                    awaitAnimationFrame()
//                                    scrollState.animateScrollBy((startPosition - endPosition).toFloat() * 4f)
//
//                                    job?.cancel()
//                                }
//                            }
//                        )
//                    }
//                }

                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .background(color = Color(0xFF1C1C1F)),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth(screenWidth)
                            .fillMaxHeight()
                            .verticalScroll(scrollState)
                            .background(color = Color(0xFF1C1C1F))
                            .padding(top = 120.dp, bottom = 24.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.logo),
                            contentDescription = "KUG LOGO",
                            modifier = Modifier.size(120.dp),
                            contentScale = ContentScale.Fit
                        )

                        Text(
                            text = "Kotlin User Groups Seoul",
                            modifier = Modifier.padding(top = 12.dp),
                            color = Color.White,
                            fontSize = if (screenWidth < 0.7f) 60.sp else 40.sp,
                            fontWeight = FontWeight.ExtraBold,
                            textAlign = TextAlign.Center,
                        )

                        Text(
                            text = "Kotlin을 사랑하는 KUG Seoul 입니다.\n좋아하는 사람은 언제나 환영입니다!",
                            color = Color.White,
                            modifier = Modifier.padding(top = 12.dp),
                            fontSize = if (screenWidth < 0.7f) 28.sp else 20.sp,
                            fontWeight = FontWeight.Normal,
                            textAlign = TextAlign.Center,
                        )

                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            RoundedButton(
                                text = "Join Us",
                                color = Color(0xFF3D60CC),
                                onClick = {
//                                    window.alert("차후 멤버 모집 예정입니다.")
                                    window.open("https://open.kakao.com/o/gBdN3dXf")
                                }
                            )

                            RoundedButton(
                                text = "Visit Github",
                                color = Color(0xFF32323D),
                                onClick = {
                                    window.open("https://github.com/Kotlin-User-Groups-Seoul")
                                }
                            )
                        }

                        Section(key = "EVENT", value = "UPCOMING EVENT!", topPadding = 80.dp) {
                            Box(
                                modifier = Modifier
                                    .padding(top = 24.dp)
                                    .fillMaxWidth()
                                    .height(200.dp)
                                    .background(
                                        color = Color(0xFF282834),
                                        shape = RoundedCornerShape(8.dp)
                                    )
                                    .padding(horizontal = 24.dp),
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    text = "KotlinConf'24 Coming Soon!",
                                    color = Color.White,
                                    fontSize = 28.sp,
                                    fontWeight = FontWeight.Medium
                                )
                            }
                        }

                        Section(key = "ORGANIZERS", value = "WE'RE FANCY ORGANIZERS!", topPadding = 80.dp) {
                            if (screenWidth <= 0.5f) {
                                Row(
                                    modifier = Modifier
                                        .padding(top = 24.dp)
                                        .fillMaxWidth(),
                                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                                ) {
                                    OrganizerProfile(
                                        modifier = Modifier.weight(1f),
                                        name = "김병수",
                                        part = "Backend Developer",
                                        drawableResource = Res.drawable.imposter
                                    )
                                    OrganizerProfile(
                                        modifier = Modifier.weight(1f),
                                        name = "유광무",
                                        part = "Mobile Developer",
                                        drawableResource = Res.drawable.pangmoo
                                    )
                                    OrganizerProfile(
                                        modifier = Modifier.weight(1f),
                                        name = "이상훈",
                                        part = "Mobile Developer",
                                        drawableResource = Res.drawable.dora
                                    )
                                    OrganizerProfile(
                                        modifier = Modifier.weight(1f),
                                        name = "이현우",
                                        part = "Mobile Developer",
                                        drawableResource = Res.drawable.nunu
                                    )
                                }
                            } else if (screenWidth <= 0.7f) {
                                Column(
                                    modifier = Modifier
                                        .padding(top = 24.dp)
                                        .fillMaxWidth(),
                                    verticalArrangement = Arrangement.spacedBy(12.dp)
                                ) {
                                    Row(
                                        modifier = Modifier.fillMaxWidth(),
                                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                                    ) {
                                        OrganizerProfile(
                                            modifier = Modifier.weight(1f),
                                            name = "김병수",
                                            part = "Backend Developer",
                                            drawableResource = Res.drawable.imposter
                                        )
                                        OrganizerProfile(
                                            modifier = Modifier.weight(1f),
                                            name = "유광무",
                                            part = "Mobile Developer",
                                            drawableResource = Res.drawable.pangmoo
                                        )
                                    }
                                    Row(
                                        modifier = Modifier.fillMaxWidth(),
                                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                                    ) {
                                        OrganizerProfile(
                                            modifier = Modifier.weight(1f),
                                            name = "이상훈",
                                            part = "Mobile Developer",
                                            drawableResource = Res.drawable.dora
                                        )
                                        OrganizerProfile(
                                            modifier = Modifier.weight(1f),
                                            name = "이현우",
                                            part = "Mobile Developer",
                                            drawableResource = Res.drawable.nunu
                                        )
                                    }
                                }
                            } else {
                                Column(
                                    modifier = Modifier
                                        .padding(top = 24.dp)
                                        .fillMaxWidth(),
                                    verticalArrangement = Arrangement.spacedBy(12.dp)
                                ) {
                                    OrganizerProfile(
                                        modifier = Modifier.fillMaxWidth(),
                                        name = "김병수",
                                        part = "Backend Developer",
                                        drawableResource = Res.drawable.imposter
                                    )
                                    OrganizerProfile(
                                        modifier = Modifier.fillMaxWidth(),
                                        name = "유광무",
                                        part = "Mobile Developer",
                                        drawableResource = Res.drawable.pangmoo
                                    )
                                    OrganizerProfile(
                                        modifier = Modifier.fillMaxWidth(),
                                        name = "이상훈",
                                        part = "Mobile Developer",
                                        drawableResource = Res.drawable.dora
                                    )
                                    OrganizerProfile(
                                        modifier = Modifier.fillMaxWidth(),
                                        name = "이현우",
                                        part = "Mobile Developer",
                                        drawableResource = Res.drawable.nunu
                                    )
                                }
                            }
                        }

                        Text(
                            text = "Developed with Compose Multiplatform",
                            modifier = Modifier.padding(top = 100.dp),
                            color = Color(0xFF454555),
                            fontSize = 16.sp
                        )
                    }

                    VerticalScrollbar(
                        adapter = rememberScrollbarAdapter(scrollState),
                        modifier = Modifier
                            .align(Alignment.CenterEnd)
                            .padding(4.dp)
                            .fillMaxHeight(),
                        style = LocalScrollbarStyle.current.copy(
                            hoverColor = Color(0xFF202026),
                            unhoverColor = Color(0xFF282834),
                        )
                    )
                }
            }
        }

    }
}

@Composable
private fun RoundedButton(text: String, color: Color, onClick: () -> Unit) {
    Button(
        onClick = onClick,
        modifier = Modifier.padding(top = 24.dp),
        shape = RoundedCornerShape(100.dp),
        colors = ButtonDefaults.buttonColors(
            backgroundColor = color,
            contentColor = Color.White
        )
    ) {
        Text(text = text, modifier = Modifier.padding(4.dp), fontSize = 16.sp)
    }
}

@Composable
private fun Section(key: String, value: String, topPadding: Dp, content: @Composable () -> Unit) {
    Column(
        modifier = Modifier.fillMaxWidth().padding(top = topPadding),
        horizontalAlignment = Alignment.Start
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = key,
                color = Color(0xFF0055FF),
                fontSize = 24.sp,
                fontWeight = FontWeight.Medium
            )
        }
        Column {
            Text(
                text = value,
                modifier = Modifier.padding(top = 12.dp).drawBehind {
                    drawLine(
                        color = Color.White,
                        start = Offset(x = 0f, y = size.height + 6f),
                        end = Offset(x = size.width, y = size.height + 6f),
                        strokeWidth = 6f
                    )
                },
                color = Color.White,
                fontSize = 32.sp,
                fontWeight = FontWeight.Bold
            )
            content()
        }
    }
}

@Composable
private fun OrganizerProfile(modifier: Modifier = Modifier, name: String, part: String, drawableResource: DrawableResource) {
    Column(
        modifier = modifier
            .background(
                color = Color(0xFF282834), // #202126
                shape = RoundedCornerShape(8.dp)
            )
            .padding(32.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            painter = painterResource(drawableResource),
            contentDescription = name,
            modifier = Modifier.size(140.dp).clip(CircleShape),
            contentScale = ContentScale.FillWidth
        )
        Text(
            text = name,
            modifier = Modifier.padding(top = 24.dp),
            color = Color.White,
            fontSize = 24.sp,
            fontWeight = FontWeight.Bold
        )
        Text(
            text = part,
            modifier = Modifier.padding(top = 4.dp),
            color = Color.White,
            fontSize = 16.sp,
            fontWeight = FontWeight.Medium
        )
    }
}

